function CreateGoal() {
    return (
        <div>
            <h1>Create Goal</h1>
        </div>
    )
}

export default CreateGoal;